// src/pages/admin/InquiriesDashboard.js
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInquiries } from '../store/thunks/inquiriesActions';
import InquiryListPanel   from '../components/InquiryListPanel';
import InquiryDetailPanel from '../components/InquiryDetailPanel';

const TABS = [
  { key: 'all',     label: 'All Inquiries' },
  { key: 'new',     label: 'New' },
  { key: 'replied', label: 'Replied' },
  { key: 'closed',  label: 'Closed' },
];

export default function InquiriesDashboard() {
  const dispatch = useDispatch();
  const { list: inquiries = [], loading } = useSelector(s => s.inquiries);
  const [activeTab, setActiveTab]   = useState('all');
  const [selectedId, setSelectedId] = useState(null);
  const lastFetchRef = useRef(0);

  const loadInquiries = useCallback(() => {
    return dispatch(fetchInquiries()).then(() => {
      lastFetchRef.current = Date.now();
    });
  }, [dispatch]);

  useEffect(() => { loadInquiries(); }, [loadInquiries]);
  useEffect(() => {
    const iv = setInterval(() => {
      if (Date.now() - lastFetchRef.current > 60_000) loadInquiries();
    }, 60_000);
    return () => clearInterval(iv);
  }, [loadInquiries]);
  useEffect(() => {
    document.body.style.overflow = selectedId ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [selectedId]);

  const filtered = useMemo(() => {
    if (activeTab === 'all') return inquiries;
    return inquiries.filter(i => {
      if (activeTab === 'new')     return !i.replied && !i.closed;
      if (activeTab === 'replied') return i.replied   && !i.closed;
      if (activeTab === 'closed')  return i.closed;
      return true;
    });
  }, [inquiries, activeTab]);

  const count = key => {
    if (key === 'all')     return inquiries.length;
    if (key === 'new')     return inquiries.filter(i => !i.replied && !i.closed).length;
    if (key === 'replied') return inquiries.filter(i => i.replied && !i.closed).length;
    if (key === 'closed')  return inquiries.filter(i => i.closed).length;
    return 0;
  };

  return (
    <div className="flex h-full w-full bg-[#F9FAFB] overflow-auto">
      {/* LEFT PANEL */}
      <div className="w-[1050px] flex-shrink-0 border-r border-[#E5E7EB] p-5 flex flex-col">
        <div className="flex space-x-2 mb-4">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`flex-1 text-center px-3 py-2 rounded-[12px] text-sm font-medium ${
                activeTab === tab.key
                  ? 'bg-[#2563EB] text-white'
                  : 'bg-white text-[#374151] hover:bg-[#F3F4F6]'
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label} ({count(tab.key)})
            </button>
          ))}
        </div>
        <div className="flex-1 overflow-y-auto">
          <InquiryListPanel
            inquiries={filtered}
            activeTab={activeTab}
            loading={loading}
            onSelect={setSelectedId}
          />
        </div>
      </div>

      {/* DETAIL OVERLAY */}
      {selectedId && (
        <>
          <div
            className="fixed inset-0 bg-transparent z-20"
            onClick={() => setSelectedId(null)}
          />
          <div className="fixed top-0 right-0 h-full w-[970px] bg-white z-30 shadow-xl overflow-y-auto flex flex-col">
            <InquiryDetailPanel
              inquiryId={selectedId}
              onClose={() => setSelectedId(null)}
            />
          </div>
        </>
      )}
    </div>
  );
}
